import NotificationMessage from "../../pages/notification-message/List";
export const NotificationMessageView = [
  //ข้อความแจ้งเตือน
  {
    path: "/notification-message",
    name: "ข้อความแจ้งเตือน",
    component: NotificationMessage,
    layout: "notification",
  },
];